// extracted by mini-css-extract-plugin
module.exports = {"image":"lead-section-module--image--2JMeY"};